import * as React from "react";
import { SVGProps } from "react";
const SvgNotification = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28 10.3V22c0 1.64-1.209 2.907-2.82 2.995L25 25H7c-1.64 0-2.907-1.209-2.995-2.82L4 22V10.3c3.494 3.589 6.989 6.464 10.82 8.879l.68.421.5.3.5-.3c3.872-2.361 7.388-5.168 10.883-8.674L28 10.3ZM7 7h18c1 0 1.8.4 2.3 1.2-3.6 3.9-7.2 6.9-11.3 9.4-4.1-2.6-7.7-5.5-11.3-9.4.467-.653 1.195-1.132 2.103-1.193L7 7Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNotification;
